// src/api/authApi.js
import api from './api';

export const signup = (username, password, userType) => {
  return api.post('/auth/signup', { username, password, userType });
};

export const login = (username, password) => {
  return api.post('/auth/login', { username, password });
};

export const deleteUser = (username) => {
  return api.delete(`/auth/user/${username}`);
};

export const updateUserStatus = (username, isActive) => {
  return api.patch(`/auth/user/${username}/status`, { isActive });
};

export const updateUserPassword = (username, password) => {
  return api.patch(`/auth/user/${username}/password`, { password });
};

export const getUsers = (params = {}) => {
  return api.get('/auth/users', { params });
};
